import React from "react";
import { Card, InputNumber, Table } from "antd";
import { observer } from "mobx-react";
import { fmtMoney2 } from "../../../common/Utils";
import { Store } from "../../../store/Store";

export const PerGoalDonateTable = observer(() => {
  const { fundView } = Store.fundsStore;

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Name",
      key: "userName",
      dataIndex: ["user", "name"],
      defaultSortOrder: "ascend" as const,
      sorter: (a, b) => a.user.name.toLocaleLowerCase().localeCompare(b.user.name.toLocaleLowerCase()),
    },
    {
      title: "Child Name",
      key: "childName",
      dataIndex: ["child", "name"],
      sorter: (a, b) => a.child.name.toLocaleLowerCase().localeCompare(b.child.name.toLocaleLowerCase()),
    },
    // {
    //   title: "Invite Family & Friends",
    //   key: "invite",
    //   // render: (_, r) => fmtMoney2((r.amount || 0) / 100.0, "-", "/" + fundView.fund.perGoal.singular),
    // },
    // {
    //   title: "Invitation from",
    //   key: "from",
    //   // render: (_, r) => fmtMoney2((r.amount || 0) / 100.0, "-", "/" + fundView.fund.perGoal.singular),
    // },
    {
      title: "Donation / Goal",
      key: "pergoal",
      render: (_, r) => fmtMoney2((r.amount || 0) / 100.0, "-", "/" + fundView.fund.perGoal.singular),
    },
    {
      title: "# of Goals Achieved",
      key: "count",
      render: (t, r, i) =>
        fundView.fund?.complete ? (
          r.count
        ) : (
          <InputNumber min={0} size="small" value={r.achieved} onChange={(v) => fundView.setPerGoalAchieved(r.id, v)} />
        ),
    },
    // {
    //   title: "Amount",
    //   key: "amount",
    //   // render: (_, r) => fmtMoney2((r.amount || 0) / 100.0, "-", "/" + fundView.fund.perGoal.singular),
    // },
    // {
    //   title: "Time",
    //   key: "createDate",
    //   render: (v) => fmtDateTime(v),
    // },
  ];

  return (
    <Card size="small" bodyStyle={{ padding: 0 }}>
      <Table
        rowKey="id"
        size="small"
        columns={columns}
        dataSource={fundView.fund.perGoalDonates}
        pagination={false}
      ></Table>
    </Card>
  );
});
